import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { humanizeRole } from '../constants/relationships';

/**
 * G5E — carrega o vocabulário de papéis (tipos_papel_contato) e expõe:
 *  - roles: [{ value, label_pt, sort_order }] para popular <select>
 *  - roleLabel(value): mapeia value -> label_pt (fallback humanizado)
 */
export function useRoleLabels() {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    supabase
      .from('tipos_papel_contato')
      .select('value, label_pt, sort_order')
      .order('sort_order')
      .then(({ data }) => {
        if (cancelled) return;
        setRoles(data || []);
        setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  const roleLabel = useCallback(
    (value) => {
      const hit = roles.find((r) => r.value === value);
      return hit ? hit.label_pt : humanizeRole(value);
    },
    [roles]
  );

  return { roles, roleLabel, loading };
}
